/* src/app/components/header/header.component.scss */
.header-wrapper .navbar {
  padding: 0px !important;
  justify-content: flex-start !important;
}
.header-wrapper nav {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.header-wrapper nav .navbar-start a {
  cursor: default;
}
.header-wrapper nav .navbar-start .nav-item {
  background: #fff;
  border-radius: 100%;
  padding: 5px;
  margin-right: 10px;
  width: 50px;
  height: 50px;
}
.header-wrapper nav .navbar-start .nav-item img {
  width: 100% !important;
}
.header-wrapper nav .navbar-start .company-detail {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.header-wrapper nav .navbar-start .company-name {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  line-height: 1.2rem;
}
.header-wrapper nav .navbar-end .navbar-link::after {
  border-color: var(--menuSelectColor) !important;
}
.header-wrapper nav .navbar-end .channel-actions {
  width: 250px !important;
  margin-top: 12px;
}
.header-wrapper nav .navbar-end .channel-actions h2 {
  position: absolute;
  right: 22em;
  top: 1.1em;
  font-weight: 500;
  color: var(--whiteColor);
}
.header-wrapper nav .navbar-end .channel-actions .company_list {
  text-transform: capitalize;
}
.header-wrapper .navbar-link {
  height: 60px;
}
.header-wrapper .navbar-link:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.header-wrapper .navbar-link img {
  border-radius: 100%;
}
.header-wrapper .navbar-item img {
  max-height: 2.15rem;
}
.header-wrapper .navbar-link .icon {
  position: absolute;
  top: 30px;
  right: 35px;
}
.header-wrapper .navbar-link .fa {
  font-size: 12px !important;
}
.header-wrapper .navbar-dropdown .navbar-item .fa {
  font-size: 12px !important;
  margin-right: 10px;
}
.header-wrapper .nested.dropdown:hover > .dropdown-menu {
  display: block;
}
.header-wrapper .nested.dropdown .dropdown-menu {
  top: -13px;
  left: -193px;
}
.header-wrapper .nested.dropdown .dropdown-content .has-text-grey {
  padding: 4px 15px;
}
.header-wrapper .nested.dropdown .dropdown-menu input {
  cursor: inherit;
}
.header-wrapper .nested.dropdown .dropdown-trigger::after {
  content: "\f105";
  font-family: FontAwesome;
  position: absolute;
  right: 14px;
}
.header-wrapper .nested.dropdown .fa {
  margin-top: 5px;
}
/*# sourceMappingURL=header.component.css.map */
